import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Typography } from "@mui/material";
import React from "react";
import { formatGeDateTime } from "../../dates";

function OrderAdditionalServicesTable() {
  const { t } = useTranslation();
  const { order, loading } = useOutletContext();

  return (
    <table className="table-auto mx-4 my-3 text-left">
      <thead className={"whitespace-nowrap"}>
        <tr>
          <th className={"pr-4"}>
            <Typography className={"font-bold"}>
              {t("orderTracking.additionalServices.date")}
            </Typography>
          </th>
          <th className={"pr-4"}>
            <Typography className={"font-bold"}>
              {t("orderTracking.additionalServices.service")}
            </Typography>
          </th>
          <th className={"pr-4"}>
            <Typography className={"font-bold"}>
              {t("orderTracking.additionalServices.cost")}
            </Typography>
          </th>
          <th className={"pr-4"}>
            <Typography className={"font-bold"}>
              {t("orderTracking.additionalServices.paymentBy")}
            </Typography>
          </th>
        </tr>
      </thead>

      <tbody>
        {order.services.map((service, index) => (
          <OrderAdditionalServiceItem service={service} index={index} />
        ))}
      </tbody>
    </table>
  );
}

function OrderAdditionalServiceItem({ service, index }) {
  const { t, i18n } = useTranslation();

  const date = formatGeDateTime(service.date);
  const serviceDescription = service.getName(i18n.language);
  const cost = `${service.amount} ${t("orderTracking.gel")}`;
  const paymentSide = service.payment_by_sender
    ? t("orderCreation.paymentSender")
    : t("orderCreation.paymentRecipient");

  return (
    <tr>
      <td className={"pr-4 py-2"}>{date}</td>
      <td className={"pr-4 py-2"}>{serviceDescription}</td>
      <td className={"pr-4 py-2 whitespace-nowrap"}>{cost}</td>
      <td className={"pr-4 py-2"}>{paymentSide}</td>
    </tr>
  );
}

export default OrderAdditionalServicesTable;
